<div class="referral-container">

  <div class="stats-section mb-4">
    <div class="stat-card border" *ngFor="let stat of stats">
      <div class="stat-icon">
        <i class="bi bi-{{stat.icon}}"></i>
      </div>
      <div class="stat-content">
        <h3 class="text-danger">{{stat.value}}</h3>
        <p>{{stat.title}}</p>
      </div>
    </div>
  </div>


  <div class="row g-4">
    <!-- Left Column - Referral List -->
    <div class="col-lg-8">
      <div class="card">
        <div class="card-header">
          <h5>Referred Users</h5>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <table class="referral-table">
              <thead>
              <tr>
                <th>User</th>
                <th>Email</th>
                <th>Signup Date</th>
              </tr>
              </thead>
              <tbody *ngIf="referredUsers && referredUsers.length > 0; else noUsers">
              <tr *ngFor="let user of referredUsers">
                <td>{{user.firstName}}</td>
                <td>{{user?.emailId || "_"}}</td>
                <td>{{user.createTimestamp | date}}</td>
              </tr>
              </tbody>
              <ng-template #noUsers>
                <tr>
                  <td colspan="3" class="text-center text-muted">No referred users found.</td>
                </tr>
              </ng-template>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- Right Column - Referral Tools -->
    <div class="col-lg-4">
      <!-- Referral Link Card -->
      <div class="card">
        <div class="card-header">
          <h5>Your Referral Link</h5>
          <button class="btn btn-sm btn-outline-danger" (click)="copyToClipboard('https://www.smartdukaan.com/associates/register'+'?referral_code=' + userCode+customer.id)">
            <i class="pi pi-copy"></i> Copy
          </button>
        </div>
        <div class="card-body">
          <div class="referral-link-box">
            <p class="referral-link">https://smartdukaan.com/associates/register?referralCode={{userCode}}{{customer.id}}</p>
          </div>
          <p class="text-muted small">Share this link with friends and earn rewards when they sign up!</p>
        </div>
      </div>

      </div>
    </div>
  </div>
